// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Recruitment_mainContainer__3kf3o"};